export const PageHeader = ({ eyebrow, title, sub, children }) => (
  <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 fade-up">
    <div>
      {eyebrow && <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground font-semibold mb-2">{eyebrow}</p>}
      <h1 className="text-3xl sm:text-4xl font-black tracking-tight" data-testid="page-title">{title}</h1>
      {sub && <p className="text-muted-foreground mt-2 text-sm">{sub}</p>}
    </div>
    {children}
  </div>
);
